import { mapContasPagarApiToView } from "layouts/pages/loja/financeiro/dashboard/helpers/map-contas-pagar-api-to-view";
import { listarContasPagar } from "layouts/pages/loja/financeiro/dashboard/services/contas-pagar.service";
import type { ContaPagarView } from "layouts/pages/loja/financeiro/dashboard/types/contas-pagar.types";

/** Lista todos os títulos a pagar do evento (paginação automática). */
export async function listarTodasDespesasEvento(
  eventoId: number,
): Promise<ContaPagarView[]> {
  const itens: ContaPagarView[] = [];
  const limit = 100;
  let page = 1;
  let totalPages = 1;

  while (page <= totalPages) {
    const { data, status } = await listarContasPagar({
      eventoId,
      contexto: "EVENTO",
      status: "",
      vencimentoInicio: "",
      vencimentoFim: "",
      categoria: "",
      naturezaDespesa: "",
      centroCustoId: "",
      fornecedorId: "",
      busca: "",
      apenasVencidos: false,
      page,
      limit,
    });

    if (status === 403 || status !== 200 || !data) {
      break;
    }

    const view = mapContasPagarApiToView(data);
    if (!view) break;

    itens.push(...view.itens);
    totalPages = Math.max(1, view.totalPages);
    page += 1;
  }

  return itens;
}
